import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useAuth } from "@clerk/react";
import { useAuthedRequest } from "@/lib/api";

const ProfileContext = createContext(null);

export function ProfileProvider({ children }) {
  const { isLoaded, isSignedIn } = useAuth();
  const request = useAuthedRequest();
  const [state, setState] = useState({ loading: true, onboarded: false, profile: null, membership: null });

  const apply = useCallback((data) => setState({ loading: false, onboarded: !!data.onboarded, profile: data.profile || null, membership: data.membership || null,
    canUpload: !!data.can_upload, freeUploads: !!data.free_uploads }), []);

  const refresh = useCallback(async () => {
    try { apply(await request("get", "/me")); } catch { setState((s) => ({ ...s, loading: false })); }
  }, [request, apply]);

  useEffect(() => {
    if (!isLoaded) return;
    if (!isSignedIn) { setState({ loading: false, onboarded: false, profile: null, membership: null }); return; }
    setState((s) => ({ ...s, loading: true }));
    refresh();
  }, [isLoaded, isSignedIn, refresh]);

  return (
    <ProfileContext.Provider value={{ ...state, loading: state.loading || !isLoaded, isSignedIn, refresh, apply, request }}>
      {children}
    </ProfileContext.Provider>
  );
}

export const useProfile = () => useContext(ProfileContext);
